import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../../../../services/API';

export default function ModalEditarLoja({ 
  show, 
  onClose, 
  revenda, 
  onSuccess 
}) {
  const [fatorPontuacao, setFatorPontuacao] = useState('1');
  const [salvando, setSalvando] = useState(false);

  const handleSave = async () => {
    if (!revenda) return;

    setSalvando(true);
    try {
      await api.put(`/api/revendas/${revenda.id}`, {
        fatorPontuacao: Number(fatorPontuacao)
      });
      
      toast.success('Fator de pontuação atualizado com sucesso', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
      onSuccess();
      onClose();
    } catch (error) {
      toast.error('Erro ao atualizar fator de pontuação', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 10000,
      });
    }
    setSalvando(false);
  };

  return (
    <Modal 
      show={show} 
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Editar Fator de Pontuação</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <label htmlFor="fatorPontuacao">Fator de Pontuação</label>
          <select
            className="form-control"
            id="fatorPontuacao"
            value={fatorPontuacao}
            onChange={(e) => setFatorPontuacao(e.target.value)}
          >
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((value) => (
              <option key={value} value={value}>
                {value}x
              </option>
            ))}
          </select>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancelar
        </Button>
        <Button 
          variant="primary" 
          onClick={handleSave}
          disabled={salvando}
        >
          {salvando ? 'Salvando...' : 'Salvar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
} 